module.exports = __webpack_public_path__ + "img/vol05_cup01_label04.92050c1c.png";